/* eslint-disable quotes */
// TODO: Add skills copy
// TODO: Add experiences copy
export default {
    app: {
        consoleMessage: {
            en: 'Hey! If you want to take a closer look at how this site was built, check out my GitHub for the source code',
            fr: 'Hé! Si vous voulez regarder de plus près comment ce site a été construit, consultez mon GitHub pour le code source',
        },
    },
    headerSection: {
        buttonLabel: {
            en: 'Contact Me',
            fr: 'Contactez moi',
        },
        emojiAlt: {
            en: 'waving hand',
            fr: 'agitant la main',
        },
        imageAlt: {
            en: 'A developer sitting at his laptop with development windows floating to his left.',
            fr: 'Un développeur assis devant son ordinateur portable avec des fenêtres de développement flottant à sa gauche.',
        },
        subtitle: {
            en: `
                Welcome to my portfolio! I'm a web developer with a passion
                for UI / UX, a desire to create pixel perfect designs, and 
                an eye for accessibility. I've been a developer for nearly 10
                years, and I currently work as one of the lead frontend developers 
                at a fintech company in Vancouver, BC. Take a look around this 
                website to see what I love, and to learn more about my work!
            `,
            fr: `
                Bienvenue dans mon portefeuille! Je suis un développeur web passionné
                pour UI / UX, un désir de créer des conceptions parfaites au pixel près, et
                un œil sur l'accessibilité. Je suis développeur depuis près de 10
                ans, et je travaille actuellement comme l'un des principaux développeurs frontend
                dans une entreprise fintech à Vancouver, en Colombie-Britannique. Jetez un oeil autour de ça
                site web pour voir ce que j'aime et en savoir plus sur mon travail !
            `,
        },
        title: {
            en: "Hi, I'm Nilay, a full stack developer!",
            fr: 'Salut, je suis Nilay, un développeur full stack!',
        },
    },
    experiencesSection: {
        emojiAlt: {
            en: 'running shoe',
            fr: 'chaussure de course',
        },
        events: {
            firstTime: {
                title: {
                    en: 'First Time Programming',
                    fr: 'Première programmation',
                },
            },
            fispanCoop: {
                title: {
                    en: 'FISPAN (Co-op)',
                    fr: 'FISPAN (coop)',
                },
            },
            fispanFullTime: {
                title: {
                    en: 'FISPAN (Full-time)',
                    fr: 'FISPAN (Temps plein)',
                },
            },
            freshWorks: {
                title: {
                    en: 'FreshWorks Studio (Co-op)',
                    fr: 'FreshWorks Studio (coop)',
                },
            },
            ta: {
                title: {
                    en: "Teacher's Assistant",
                    fr: "L'assistant du professeur",
                },
            },
            universityEnd: {
                title: {
                    en: 'Finished BSc at UVic',
                    fr: "BSc terminé à l'UVic",
                },
            },
            universityEss: {
                title: {
                    en: 'Student Director of IT at UVic',
                    fr: "Directeur étudiant de IT à l'UVic",
                },
            },
            universityStart: {
                title: {
                    en: 'Started BSc at UVic',
                    fr: "Début d'un BSc à l'UVic",
                },
            },
        },
        subtitle: {
            en: `
                Over my decade long journey as a developer, I've had the opportunity to learn,
                work, and grow at several different places in many different roles. I first 
                started programming in high school, where I learned the basics of web development,
                writing clean and concise code, and how to find missing semicolons. There I built a
                baby photo uploader for the yearbook class, and served as a teacher's assistant,
                assisting new coders with their projects and assignments. I then continued my
                programming journey at university, where I learned about network protocols, software 
                testing, and the software development lifecycle, as well as some scary math disguised 
                as computer science classes. During this time, I was also able to apply what I learned
                at my two co-op jobs, where I worked on projects for real clients and users as a full 
                stack developer. After graduating, I joined a fintech company full-time, and have
                continued to grow as a developer! Click a node for more details.
            `,
            fr: `
                Au cours de mon parcours d'une décennie en tant que développeur, j'ai eu l'occasion d'apprendre,
                travailler et grandir à plusieurs endroits différents dans de nombreux rôles différents. Je l'ai fait en premier
                commencé la programmation au lycée, où j'ai appris les bases du développement web,
                écrire du code propre et concis, et comment trouver les points-virgules manquants. Là, j'ai construit un
                téléchargeur de photos de bébé pour la classe de l'annuaire et a servi d'assistant d'enseignant,
                aider les nouveaux codeurs dans leurs projets et missions. J'ai ensuite poursuivi mon
                parcours de programmation à l'université, où j'ai appris les protocoles réseau, les logiciels
                les tests et le cycle de vie du développement logiciel, ainsi que des calculs effrayants déguisés
                que des cours d'informatique. Pendant ce temps, j'ai également pu appliquer ce que j'ai appris
                à mes deux emplois coopératifs, où j'ai travaillé sur des projets pour de vrais clients et utilisateurs en tant que
                développeur de pile. Après avoir obtenu mon diplôme, j'ai rejoint une entreprise fintech à temps plein et j'ai
                continué à grandir en tant que développeur! Cliquez sur un nœud pour plus de détails.
            `,
        },
        title: {
            en: 'A walk in my shoes',
            fr: 'Une promenade dans mes chaussures',
        },
        wip: {
            imgAlt: {
                en: 'An electrician changing plugging in some wires, with a toolbox near his foot',
                fr: 'Un électricien changeant de brancher des fils, avec une boîte à outils près de son pied',
            },
            title: {
                en: 'Still plugging a few things in...',
                fr: 'Reste à brancher quelques trucs...',
            },
            subtitle: {
                en: 'This is a work in progress! Check back soon :)',
                fr: "C'est un travail en cours de réalisation! Revenez bientôt :)",
            },
        },
    },
    footerSection: {
        contactInfo: {
            en: 'Contact',
            fr: 'Contact',
        },
        externalLinks: {
            en: 'External Links',
            fr: 'Liens externes',
        },
    },
    navbar: {
        about: {
            en: 'About',
            fr: 'Sur',
        },
        ariaLabel: {
            en: 'Portfolio sections',
            fr: 'Rubriques du portefeuille',
        },
        experience: {
            en: 'Experience',
            fr: 'Vivre',
        },
        other: {
            en: 'Other',
            fr: 'Autre',
        },
        personal: {
            en: 'Portfolio',
            fr: 'Portefeuille',
        },
        skills: {
            en: 'Skills',
            fr: 'Compétences',
        },
    },
    otherSection: {
        cards: {
            animationRules: {
                subtitle: {
                    en: 'Good animations make a website feel fun. Great animations add value to the user experience and feel like magic!',
                    fr: "De superbes animations ajoutent de la valeur à l'expérience utilisateur et donnent l'impression d'être magiques!",
                },
                title: {
                    en: 'Rules of Motion',
                    fr: 'Règles de mouvement',
                },
            },
            containerQueries: {
                subtitle: {
                    en: "A better way to create responsive components is on its way! @container queries allow resizing based on the parent component's size.",
                    fr: 'Les requêtes @container permettent le redimensionnement en fonction de la taille du composant parent.',
                },
                title: {
                    en: 'Resized',
                    fr: 'Redimensionné',
                },
            },
            cscApp: {
                subtitle: {
                    en: 'A website that displayed visitor submitted photos and their stories on a postcard wall. Includes an admin portal!',
                    fr: 'Un site Web qui affichait les photos soumises par les visiteurs et leurs histoires sur un mur de cartes postales.',
                },
                title: {
                    en: 'Telling a Story',
                    fr: 'Raconter une histoire',
                },
            },
            gmbApp: {
                subtitle: {
                    en: "A Hootsuite integration with the Google My Business service that allows business owners to manage their business' reviews, questions, and posts.",
                    fr: "Une intégration Hootsuite avec le service Google My Business qui permet aux propriétaires d'entreprise de gérer leurs avis, questions et publications.",
                },
                title: {
                    en: 'Something Suite',
                    fr: 'Quelque chose Suite',
                },
            },
            portfolioFirstVersion: {
                subtitle: {
                    en: "This is the first portfolio I ever made back in 2019! It's made without any frameworks, and is almost purely HTML and CSS.",
                    fr: "C'est le premier portfolio que j'ai réalisé en 2019 ! Il est fait sans aucun framework, et est presque purement HTML et CSS.",
                },
                title: {
                    en: 'My First Portfolio',
                    fr: 'Portefeuille V1',
                },
            },
            portfolioSecondVersion: {
                subtitle: {
                    en: 'This an updated version of my portfolio, made with React. A lot better than V1, but very inaccessible, and starting to look a little outdated.',
                    fr: 'Ceci est une version mise à jour de mon portfolio, réalisée avec React. Beaucoup mieux que V1, mais commence à paraître un peu dépassé.',
                },
                title: {
                    en: 'Portfolio V2',
                    fr: 'Portefeuille V2',
                },
            },
            portals: {
                subtitle: {
                    en: "What if iframes weren't just a black box to unknown content? Portals let you seamlessly move from one webpage to another, as if they were the same app!",
                    fr: "Les portails vous permettent de passer de manière transparente d'une page Web à une autre, comme s'il s'agissait de la même application!",
                },
                title: {
                    en: 'A Quick Peek',
                    fr: "Un coup d'oeil rapide",
                },
            },
            scrollShadows: {
                subtitle: {
                    en: 'A CSS-only way to implement scroll indicators that disappear once the end of the content is reached!',
                    fr: "Un moyen uniquement CSS d'implémenter des indicateurs de défilement qui disparaissent une fois la fin du contenu atteinte!",
                },
                title: {
                    en: 'Into the Shadows',
                    fr: "Dans l'ombre",
                },
            },
            useSaferApp: {
                subtitle: {
                    en: 'An admin dashboard that allows BCEHS employees to track drug overdoses submitted through the UseSafer mobile app.',
                    fr: "Un tableau de bord d'administration qui permet aux employés du BCEHS de suivre les surdoses de drogue signalées.",
                },
                title: {
                    en: 'Safety First',
                    fr: "La sécurité d'abord",
                },
            },
            webTransitions: {
                subtitle: {
                    en: 'Finally, a way to smoothly transition elements between pages! The Web Transitions API brings us one step closer to seamless navigation!',
                    fr: "Enfin, un moyen de faire passer en douceur les éléments entre les pages! L'API Web Transitions nous rapproche d'une navigation fluide!",
                },
                title: {
                    en: 'Sharing is Caring',
                    fr: "Partager c'est aimer",
                },
            },
        },
        cardsToggle: {
            leftLabel: {
                en: 'Projects',
                fr: 'Projets',
            },
            rightLabel: {
                en: 'Articles',
                fr: 'Des articles',
            },
        },
        emojiAlt: {
            en: 'crystal ball',
            fr: 'boule de cristal',
        },
        subtitle: {
            en: `
                Being a developer means that you're forever a student - learning from others and your
                own past to build a better you for the future. The code you write today should always
                be better than the code you wrote yesterday! An esential part of this growth is keeping
                up with the state of technology. A new CSS property, JavaScript function, or web API is
                announced almost daily, and each one can help us write better code, and create a better
                experience for our end users. In the spirit of looking back at how much we've grown, and
                moving up to the next level, the following is a collection of my past projects, and some 
                articles that preview the future of web development! Unfortunately, some of the projects 
                I've worked on are not publicly available, so I'm unable to showcase them or their code 
                here. Some of the other projects I've worked on are a Chrome extension for managing bill 
                payments, and a banking portal companion app that allows for invoice capture, bill management,
                payment history, and transaction reporting.
            `,
            fr: `
                Être développeur signifie que vous êtes toujours un étudiant - apprenant des autres et de votre
                propre passé pour construire un meilleur vous pour l'avenir. Le code que vous écrivez aujourd'hui doit toujours
                être meilleur que le code que vous avez écrit hier! Une partie essentielle de cette croissance consiste à maintenir
                avec l'état de la technologie. Une nouvelle propriété CSS, fonction JavaScript ou API Web est
                annoncé presque quotidiennement, et chacun peut nous aider à écrire un meilleur code et à créer un meilleur
                expérience pour nos utilisateurs finaux. Dans l'esprit de regarder en arrière à quel point nous avons grandi, et
                passer au niveau suivant, ce qui suit est une collection de mes projets passés, et certains
                des articles qui préfigurent l'avenir du développement web ! Malheureusement, certains projets
                sur lesquels j'ai travaillé ne sont pas accessibles au public, je ne peux donc pas les présenter ni leur code
                ici. Certains des autres projets sur lesquels j'ai travaillé sont une extension Chrome pour la gestion des factures
                paiements, et une application compagnon de portail bancaire qui permet la capture de factures, la gestion des factures,
                l'historique des paiements et les rapports sur les transactions.
            `,
        },
        title: {
            en: 'Looking back and moving up',
            fr: 'Regarder en arrière et monter',
        },
        viewLink: {
            en: 'View Link',
            fr: 'Voir le lien',
        },
    },
    skillsSection: {
        emojiAlt: {
            en: 'person juggling',
            fr: 'personne qui jongle',
        },
        skillFilters: {
            all: {
                en: 'All',
                fr: 'Toute',
            },
            backend: {
                en: 'Backend',
                fr: 'Backend',
            },
            frontend: {
                en: 'Frontend',
                fr: 'Frontend',
            },
            learning: {
                en: 'Learning',
                fr: 'Apprentissage',
            },
        },
        skills: {
            accessibility: {
                banner: {
                    content: {
                        en: "Did you know there's a special font that makes text easier to read for people with dyslexia?",
                        fr: "Saviez-vous qu'il existe une police spéciale qui rend le texte plus facile à lire pour les personnes dyslexiques?",
                    },
                    emojiAlt: {
                        en: 'light bulb',
                        fr: 'ampoule',
                    },
                },
                bullets: {
                    en: [
                        'Created fully accessible, reusable Banner, Button, Dropdown, Icon, Navbar, Popup, and RadioButton components',
                        'Worked with design team to convert existing brand colors to accessible ones that met the WCAG2.1 standard for minimum contrast ratios',
                        'Implemented skip links and keyboard navigation with proper focus stylings and tabbing order across several React apps',
                        'Resolved 100% of critical, high and medium accessibility issues identified in evaluations conducted by a third-party auditor',
                        'Wrote internal documentation on how to ensure applications are accessible, why accessibility is important, and how to use internal accessibility utilities',
                        'While the Chrome Lighthouse accessibility audit is not comprehensive, you can see this website achieves a score of 100!',
                    ],
                    fr: [
                        'Création de composants Banner, Button, Dropdown, Icon, Navbar, Popup et RadioButton entièrement accessibles et réutilisables',
                        "A travaillé avec l'équipe de conception pour convertir les couleurs de la marque existantes en couleurs accessibles qui répondent à la norme WCAG2.1 pour les rapports de contraste minimum",
                        'Mise en œuvre des liens de saut et de la navigation au clavier avec des styles de mise au point et un ordre de tabulation appropriés dans plusieurs applications React',
                        "Résolution de 100% des problèmes d'accessibilité critiques, élevés et moyens identifiés lors des évaluations menées par un auditeur tiers",
                        "Rédaction d'une documentation interne expliquant comment s'assurer que les applications sont accessibles, pourquoi l'accessibilité est importante et comment utiliser les utilitaires d'accessibilité internes",
                        "Bien que l'audit d'accessibilité de Chrome Lighthouse ne soit pas exhaustif, vous pouvez constater que ce site Web obtient un score de 100!",
                    ],
                },
                bulletsDescription: {
                    en: "Here are just a few things that I've implemented that improved accessbility:",
                    fr: "Voici quelques éléments que j'ai mis en œuvre pour améliorer l'accessibilité:",
                },
                description: {
                    en: `
                        Accessibility is an essential part of every website and application. Many people
                        across the world have a disabilty that affects their vision, mobility, or cognitive
                        ability. This can make it dificult for them to navigate web pages that don't have 
                        accessibility accomodations, even with the help of technologies like screen readers.
                        During my time at FISPAN, we went through several externally conducted accessibility
                        evaluations, where I learned a ton about accessibility, and about how many ARIA tags 
                        exist. Accessibility is one of those things that is always evolving, with new
                        accomodations being developed every day, and so I'm always learning new
                        ways to develop accessible applications!
                    `,
                    fr: `
                        L'accessibilité est un élément essentiel de chaque site Web et application. Beaucoup de gens
                        à travers le monde ont un handicap qui affecte leur vision, leur mobilité ou leurs facultés cognitives
                        aptitude. Cela peut leur compliquer la navigation sur des pages Web qui n'ont pas
                        accommodements d'accessibilité, même avec l'aide de technologies comme les lecteurs d'écran.
                        Pendant mon séjour à la FISPAN, nous avons traversé plusieurs tests d'accessibilité menés en externe
                        évaluations, où j'ai beaucoup appris sur l'accessibilité et sur le nombre de balises ARIA
                        exister. L'accessibilité fait partie de ces choses qui évoluent constamment, avec de nouvelles
                        logements sont développés chaque jour, et donc j'apprends toujours de nouvelles
                        façons de développer des applications accessibles !
                    `,
                },
                title: {
                    en: 'Accessibility',
                    fr: 'Accessibilité',
                },
            },
            animations: {
                bullets: {
                    en: [
                        'Added microinteractions throughout several React applications, making it easier for users to see when an action was performed',
                        'Implemented global application loaders in the form of progress bars, skeleton loaders, and full page loading GIFs',
                        'Created reusable, customizable, animation utilities and components that make it easier for other developers to implement animations',
                        'Used Framer Motion to create more advanced shared layout, spring-based, and reordering animations',
                        'Developed a Walkthrough component that animates between items, while auto-positioning to always fit in the viewport',
                        'Developed custom bar and circle graphs with dynamic axis labels that smoothly transition between sizes',
                        'Spam click the "Portfolio" button in the navbar (on desktop) and watch what happens!',
                    ],
                    fr: [
                        'Ajout de micro-interactions dans plusieurs applications React, permettant aux utilisateurs de voir plus facilement quand une action a été effectuée',
                        "Implémentation de chargeurs d'application globaux sous la forme de barres de progression, de chargeurs squelettes et de GIF de chargement de page complète",
                        "Création d'utilitaires et de composants d'animation réutilisables et personnalisables qui facilitent la mise en œuvre d'animations par d'autres développeurs",
                        'Utilisation de Framer Motion pour créer des animations de mise en page partagée plus avancées, basées sur des ressorts et de réorganisation',
                        "Développé un composant Walkthrough qui s'anime entre les éléments, tout en se positionnant automatiquement pour toujours s'adapter à la fenêtre d'affichage",
                        "Développé des graphiques à barres et circulaires personnalisés avec des étiquettes d'axe dynamiques qui passent en douceur entre les tailles",
                        'Spam, cliquez sur le bouton "Portefeuille" dans la barre de navigation (sur le bureau) et regardez ce qui se passe!',
                    ],
                },
                bulletsDescription: {
                    en: "Here are a few examples of animation-related tasks I've done:",
                    fr: "Voici quelques exemples de tâches liées à l'animation que j'ai effectuées:",
                },
                description: {
                    en: `
                        Animations, transitions, and microinteractions are some of my favorite things to work on
                        when developing an application! Apart from looking cool and being fun to build, they can
                        add real value to an application when implemented correctly. Animations help indicate change,
                        and can be used to subtly redirect user focus to a new region. Transitions can be used to show
                        that information has changed, and can help decrease percieved loading time by gradually
                        changing between states. Microinteractions can provide feedback to users, and help indicate 
                        that an action has been completed, or is in progress. They also make an application feel more
                        polished and fun to use! 
                    `,
                    fr: `
                        Les animations, les transitions et les micro-interactions sont quelques-unes de mes choses préférées sur lesquelles travailler
                        lors du développement d'une application ! En plus d'avoir l'air cool et d'être amusants à construire, ils peuvent
                        ajouter une valeur réelle à une application lorsqu'elle est correctement implémentée. Les animations aident à indiquer le changement,
                        et peut être utilisé pour rediriger subtilement l'attention de l'utilisateur vers une nouvelle région. Les transitions peuvent être utilisées pour montrer
                        ces informations ont changé et peuvent aider à réduire le temps de chargement perçu en
                        changeant entre les états. Les microinteractions peuvent fournir des commentaires aux utilisateurs et aider à indiquer
                        qu'une action est terminée ou en cours. Ils permettent également à une application de se sentir plus
                        poli et amusant à utiliser!
                    `,
                },
                title: {
                    en: 'Animations',
                    fr: 'Animations',
                },
            },
            elasticSearch: {
                bullets: {
                    en: [
                        'Created multiple environment-sandboxed indices for storing data such as clients, payment batches, and vendors',
                        'Wrote aggregations for compiling payment and client statistics using built-in Elasticsearch methods',
                        'Developed API endpoints for dynamic filtering of documents with pagination support',
                        'Created custom tokenizers and analyzers for better querying of fields that contained file names, emails, and case-insensitive data',
                        'Wrote developer doucmentation that explains how to use our Elasticsearch infrastructure, why we use it, and how to solve some common errors',
                    ],
                    fr: [
                        "Création de plusieurs index d'environnement en bac à sable pour stocker des données telles que les clients, les lots de paiements et les fournisseurs",
                        "Écrit des agrégations pour compiler des statistiques de paiement et de clients à l'aide des méthodes intégrées d'Elasticsearch",
                        "Développement de points de terminaison d'API pour le filtrage dynamique des documents avec prise en charge de la pagination",
                        "Création de tokenizers et d'analyseurs personnalisés pour une meilleure interrogation des champs contenant des noms de fichiers, des e-mails et des données insensibles à la casse",
                        "Rédaction d'une documentation destinée aux développeurs qui explique comment utiliser notre infrastructure Elasticsearch, pourquoi nous l'utilisons et comment résoudre certaines erreurs courantes",
                    ],
                },
                bulletsDescription: {
                    en: "The following are tasks that I've completed that involved the use of the Elasticsearch development console, as well as their Node.js SDK:",
                    fr: "Voici les tâches que j'ai effectuées et qui impliquaient l'utilisation de la console de développement Elasticsearch, ainsi que leur SDK Node.js:",
                },
                description: {
                    en: `
                        Elasticsearch is one of the coolest backend services I've had the pleasure of working with.
                        it allows you to create your own customized search engine that's tailored to your data. Its
                        inverted-index data structure makes it lightning fast for fuzzy-searching, filtering, and 
                        aggregating data based on multiple fields. I used this to enable advanced filtering for 
                        payment batches and clients, which allowed our internal operations team at FISPAN to search
                        through millions of documents in seconds.
                    `,
                    fr: `
                        Elasticsearch est l'un des meilleurs services backend avec lesquels j'ai eu le plaisir de travailler.
                        il vous permet de créer votre propre moteur de recherche personnalisé, adapté à vos données. Son
                        la structure de données à index inversé le rend ultra-rapide pour la recherche floue, le filtrage et
                        agréger des données basées sur plusieurs champs. Je l'ai utilisé pour activer le filtrage avancé pour
                        lots de paiement et clients, ce qui a permis à notre équipe des opérations internes au FISPAN de rechercher
                        parcourir des millions de documents en quelques secondes.
                    `,
                },
                title: {
                    en: 'Elasticsearch',
                    fr: 'Elasticsearch',
                },
            },
            kotlin: {
                bullets: {
                    en: [
                        'Added a new endpoint that grouped and counted open bills by currency code',
                        'Modified filtering endpoints to accept new filter parameters',
                        'Inspected Kotlin API endpoints for request params and response structure when API documentation was unavailable',
                    ],
                    fr: [
                        "Ajout d'un nouveau point de terminaison qui regroupait et comptait les factures ouvertes par code de devise",
                        'Points de terminaison de filtrage modifiés pour accepter de nouveaux paramètres de filtre',
                        "Inspection des points de terminaison de l'API Kotlin pour les paramètres de demande et la structure de réponse lorsque la documentation de l'API n'était pas disponible",
                    ],
                },
                bulletsDescription: {
                    en: 'I still have a lot to learn when it comes to programming in Kotlin, but here are some of the tasks I have done:',
                    fr: "J'ai encore beaucoup à apprendre en matière de programmation en Kotlin, mais voici quelques-unes des tâches que j'ai effectuées:",
                },
                description: {
                    en: `
                        Kotlin is pretty cool language that we used for several of our microservices at FISPAN. While
                        I haven't written a lot of Kotlin code just yet, I have learned the basics of how it works 
                        while reading through the microservices' code to see what params each endpoint requires. The
                        built-in functions like "takeIf" and "groupBy" are things I wish were natively implemented in
                        JavaScript!
                    `,
                    fr: `
                        Kotlin est un langage plutôt cool que nous avons utilisé pour plusieurs de nos microservices au FISPAN. Alors que
                        Je n'ai pas encore écrit beaucoup de code Kotlin, j'ai appris les bases de son fonctionnement
                        tout en lisant le code des microservices pour voir les paramètres requis par chaque point de terminaison. La
                        les fonctions intégrées comme "takeIf" et "groupBy" sont des choses que j'aimerais avoir implémentées nativement dans
                        JavaScript!
                    `,
                },
                title: {
                    en: 'Kotlin',
                    fr: 'Kotlin',
                },
            },
            microservices: {
                bullets: {
                    en: [
                        'Used messaging queue events between two microservices to migrate 600,000 vendors from a PostgreSQL database to Elasticsearch',
                        'Created a permission managing microservice in Node.js and MongoDB',
                        'Developed event-based side-effects for updating Elasticsearch documents using messaging queues',
                        'Extracted a microservice from a central Git repository into its own repository with its own CI/CD pipeline, allowing for faster updates and deployments',
                    ],
                    fr: [
                        "Événements de file d'attente de messagerie utilisés entre deux microservices pour migrer 600 000 fournisseurs d'une base de données PostgreSQL vers Elasticsearch",
                        "Création d'un microservice de gestion des autorisations dans Node.js et MongoDB",
                        "Développement d'effets secondaires basés sur des événements pour la mise à jour de documents Elasticsearch à l'aide de files d'attente de messagerie",
                        "Extrait d'un microservice d'un référentiel Git central vers son propre référentiel avec son propre pipeline CI/CD, permettant des mises à jour et des déploiements plus rapides",
                    ],
                },
                bulletsDescription: {
                    en: "I'm still learning about the intricacies of microservice architecture, but I have completed the following:",
                    fr: "J'apprends encore les subtilités de l'architecture de microservice, mais j'ai terminé ce qui suit:",
                },
                description: {
                    en: `
                        Microservices help break down large, complex systems into smaller, more manageable chunks.
                        It makes code easier to maintain, easier to test, and easier to split responsibility between
                        teams. It also allows services to be scaled independently when deployed. This means that 
                        service A can have two deployed instances to handle a higher volume of events, while service
                        B has only one node deployed.
                    `,
                    fr: `
                        Les microservices aident à décomposer les grands systèmes complexes en morceaux plus petits et plus faciles à gérer.
                        Cela rend le code plus facile à maintenir, plus facile à tester et plus facile à répartir les responsabilités entre
                        équipes. Il permet également aux services d'être mis à l'échelle indépendamment lors du déploiement. Cela signifie que
                        le service A peut avoir deux instances déployées pour gérer un plus grand volume d'événements, tandis que le service
                        B n'a qu'un seul nœud déployé.
                    `,
                },
                title: {
                    en: 'Microservices',
                    fr: 'Microservices',
                },
            },
            mongoDb: {
                bullets: {
                    en: [
                        'Used MongoDB for storing versionable permission sets that could be used to prompt users to update permissions when out-dated',
                        'Created a database for storing client preferences, such as email template colors, new feature flags, and notification preferences',
                    ],
                    fr: [
                        "Utilisé MongoDB pour stocker des ensembles d'autorisations versionnables qui pourraient être utilisés pour inviter les utilisateurs à mettre à jour les autorisations lorsqu'elles sont obsolètes",
                        "Création d'une base de données pour stocker les préférences des clients, telles que les couleurs des modèles d'e-mails, les nouveaux drapeaux de fonctionnalités et les préférences de notification",
                    ],
                },
                bulletsDescription: {
                    en: 'Being a database, it supports all the usual CRUD functionality. The following are high level descriptions of tasks where I utilized MongoDB:',
                    fr: "En tant que base de données, il prend en charge toutes les fonctionnalités CRUD habituelles. Voici les descriptions de haut niveau des tâches pour lesquelles j'ai utilisé MongoDB:",
                },
                description: {
                    en: `
                        MongoDB is a NoSQL database that uses freeform documents instead of strictly defined table 
                        rows. This allows for a more flexible and extensible data storage model when compared to SQL.
                        It stores documents with a JSON-like structure, making it easy to read and query, especially
                        when coming from a JavaScript background.
                    `,
                    fr: `
                        MongoDB est une base de données NoSQL qui utilise des documents de forme libre au lieu d'une table strictement définie
                        Lignes. Cela permet un modèle de stockage de données plus flexible et extensible par rapport à SQL.
                        Il stocke les documents avec une structure de type JSON, ce qui facilite la lecture et l'interrogation, en particulier
                        lorsqu'il vient d'un arrière-plan JavaScript.
                    `,
                },
                title: {
                    en: 'MongoDB',
                    fr: 'MongoDB',
                },
            },
            node: {
                bullets: {
                    en: [
                        'Created a permission managing microservice with an associated management API',
                        'Worked with an existing microservice to manage ElasticSearch indexes',
                        'Wrote a migration to move 600,000 vendors from PostgreSQL to ElasticSearch that required consuming multiple paginated queue events',
                        'Wrote automation scripts to create new React apps from a boilerplate, link local NPM packages, and update packages across multiple apps at once',
                        'Used several external Node.js SDKs for interacting with third-party services (ElasticSearch, MongoDB, etc.)',
                    ],
                    fr: [
                        "Création d'un microservice de gestion des autorisations avec une API de gestion associée",
                        'A travaillé avec un microservice existant pour gérer les index ElasticSearch',
                        "Écrit une migration pour déplacer 600 000 fournisseurs de PostgreSQL vers ElasticSearch qui nécessitait de consommer plusieurs événements de file d'attente paginés",
                        "Écrit des scripts d'automatisation pour créer de nouvelles applications React à partir d'un passe-partout, lier des packages NPM locaux et mettre à jour des packages sur plusieurs applications à la fois",
                        'Utilisé plusieurs SDK externes Node.js pour interagir avec des services tiers (ElasticSearch, MongoDB, etc.)',
                    ],
                },
                bulletsDescription: {
                    en: "Some backend tasks that I've completed using Node.js are:",
                    fr: "Certaines tâches backend que j'ai effectuées à l'aide de Node.js sont:",
                },
                description: {
                    en: `
                        Discovering that I could use JavaScript to write backend code was one of the best moments of
                        my development career. It made it almost trivial to move between writing backend and frontend code,
                        since I no longer had to worry about different syntaxes, variable typings, or varying built-in 
                        functions ("is it .includes() or .contains()?" was a question I used to ask myself hourly). 
                        Since then, it's felt like the learning curve of integrating new third-party services has 
                        become a lot less steep, making it easier for me to learn more technologies even faster.
                    `,
                    fr: `
                        Découvrir que je pouvais utiliser JavaScript pour écrire du code backend a été l'un des meilleurs moments de
                        ma carrière de développement. Il était presque trivial de passer de l'écriture de code backend à frontend,
                        puisque je n'avais plus à me soucier des différentes syntaxes, des typages de variables ou des variables intégrées
                        fonctions ("est-ce .includes() ou .contains()?" était une question que je me posais toutes les heures).
                        Depuis lors, on a l'impression que la courbe d'apprentissage de l'intégration de nouveaux services tiers a
                        devenir beaucoup moins raide, ce qui me permet d'apprendre plus de technologies encore plus rapidement.
                    `,
                },
                title: {
                    en: 'Node.js',
                    fr: 'Node.js',
                },
            },
            react: {
                bullets: {
                    en: [
                        'Developed dozens of reusable, accessible, and themeable components, all adhering to a common design system',
                        'Created and deployed multiple React apps from scratch, integrating other libraries like Redux, Framer Motion, Material UI, and Ramda (functional programming)',
                        'Worked with both class and functional components (functional for the win!)',
                        'Added bill payment and transaction exporting functionality into a Chrome Extension for QuickBooks Online',
                        'Created reusable hooks to prevent the repetition of logic between UI components',
                        'Utilized built-in React features like hooks, global error bounds and contexts',
                        'This website is built with React, Framer Motion, and Ramda!',
                    ],
                    fr: [
                        'Développé des dizaines de composants réutilisables, accessibles et thématiques, tous adhérant à un système de conception commun',
                        "Création et déploiement de plusieurs applications React à partir de zéro, intégrant d'autres bibliothèques telles que Redux, Framer Motion, Material UI et Ramda (programmation fonctionnelle)",
                        'A travaillé avec des composants de classe et fonctionnels (fonctionnels pour la victoire!)',
                        "Ajout d'une fonctionnalité de paiement de factures et d'exportation de transactions dans une extension Chrome pour QuickBooks en ligne",
                        "Création de crochets réutilisables pour empêcher la répétition de la logique entre les composants de l'interface utilisateur",
                        "Utilisation des fonctionnalités React intégrées telles que les crochets, les limites d'erreur globales et les contextes",
                        'Ce site Web est construit avec React, Framer Motion et Ramda!',
                    ],
                },
                bulletsDescription: {
                    en: "Here are just a few of the things I've done with React over the last few years:",
                    fr: "Voici quelques-unes des choses que j'ai faites avec React au cours des dernières années:",
                },
                description: {
                    en: `
                        I first learned React in 2019, back when I started my very first co-op. At that point, I had
                        only ever used vanilla JavaScript, and honestly was not a huge fan of it. But after learning
                        React, that all changed! React's approach to compartmentalizing code into reusable chunks, and
                        its built-in component-level state management made creating user interfaces a much smoother 
                        experience. Since then, I've had a ton of experience building applications with React and 
                        Redux, from admin dashboards, to sign-up pages, to payment management tables, to even Chrome
                        extensions!
                    `,
                    fr: `
                        J'ai appris React pour la première fois en 2019, lorsque j'ai lancé ma toute première coopérative. A ce moment-là, j'avais
                        n'a jamais utilisé que du JavaScript vanille, et honnêtement, il n'en était pas un grand fan. Mais après avoir appris
                        Réagissez, tout a changé ! L'approche de React pour compartimenter le code en morceaux réutilisables, et
                        sa gestion intégrée de l'état au niveau des composants a rendu la création d'interfaces utilisateur beaucoup plus fluide
                        vivre. Depuis lors, j'ai eu une tonne d'expérience dans la création d'applications avec React et
                        Redux, des tableaux de bord d'administration aux pages d'inscription, en passant par les tableaux de gestion des paiements, et même Chrome
                        rallonges!
                    `,
                },
                title: {
                    en: 'React',
                    fr: 'React',
                },
            },
            scss: {
                bullets: {
                    en: [
                        'Used SCSS nesting to scope and organize CSS classes',
                        'Utilized built-in features like @mixins, @imports, and loops to decrease styling repetiton',
                        'Worked with BEM (Block, Element, Modifier) syntax to create clean and consistent class names',
                    ],
                    fr: [
                        "Utilisation de l'imbrication SCSS pour définir et organiser les classes CSS",
                        'Utilisation de fonctionnalités intégrées telles que @mixins, @imports et boucles pour réduire la répétition du style',
                        'A travaillé avec la syntaxe BEM (Block, Element, Modifier) pour créer des noms de classe propres et cohérents',
                    ],
                },
                bulletsDescription: {
                    en: "Below are just a few of the ways I've used SCSS to create clean CSS:",
                    fr: "Vous trouverez ci-dessous quelques-unes des façons dont j'ai utilisé SCSS pour créer un CSS propre:",
                },
                description: {
                    en: `
                        One thing all developers can relate to is how much effort it is to maintain CSS. From 
                        conflicting class names to specificity clashes, to even just reusing common snippets, it can
                        be a lot of work to write CSS that doesn't become unwieldly very quickly. SCSS helps solve a
                        lot of these concerns by providing built-in features like @mixins for reusing common styles
                        and class nesting to help scope styles to a specific component. I've used SCSS for almost every
                        every project I've worked on, and many of its features are so intuitive that they feel like they
                        should be baked into CSS itself. 
                    `,
                    fr: `
                        Une chose à laquelle tous les développeurs peuvent s'identifier est l'effort nécessaire pour maintenir le CSS. De
                        des noms de classe en conflit à des conflits de spécificité, même simplement en réutilisant des extraits communs, cela peut
                        être beaucoup de travail pour écrire du CSS qui ne devient pas très vite encombrant. SCSS aide à résoudre un
                        beaucoup de ces préoccupations en fournissant des fonctionnalités intégrées telles que @mixins pour réutiliser les styles courants
                        et l'imbrication de classes pour aider à étendre les styles à un composant spécifique. J'ai utilisé SCSS pour presque tous
                        tous les projets sur lesquels j'ai travaillé, et bon nombre de ses fonctionnalités sont si intuitives qu'elles donnent l'impression qu'elles
                        devrait être intégré au CSS lui-même.
                    `,
                },
                title: {
                    en: 'SCSS',
                    fr: 'SCSS',
                },
            },
            sql: {
                bullets: {
                    en: [
                        'Created efficient, paginated queries for migrating 600,000 vendors from PostgreSQL to ElasticSearch',
                        'Wrote analytics queries for aggregating usage data for a Hootsuite / Google My Business plugin',
                        "Worked with AWS RedShift queries to structure data from a data lake for inspecting a client's lifespan on our product",
                    ],
                    fr: [
                        'Création de requêtes efficaces et paginées pour la migration de 600 000 fournisseurs de PostgreSQL vers ElasticSearch',
                        "Rédaction de requêtes analytiques pour agréger les données d'utilisation d'un plugin Hootsuite / Google My Business",
                        "A travaillé avec les requêtes AWS RedShift pour structurer les données d'un lac de données afin d'inspecter la durée de vie d'un client sur notre produit",
                    ],
                },
                bulletsDescription: {
                    en: "SQL is far from my favourite language, but I've had a fair bit of experience working with it:",
                    fr: "SQL est loin d'être mon langage préféré, mais j'ai eu une bonne expérience de travail avec:",
                },
                description: {
                    en: `
                        SQL and PostgreSQL are the most prominent technologies used for database operations in use today.
                        They offer all the basic CRUD operations as well as advanced features for performing analytics.
                        Unlike MongoDB, it is a relational database management system, meaning that all data is to be 
                        stored in well-structured rows with fixed columns.
                    `,
                    fr: `
                        SQL et PostgreSQL sont les technologies les plus utilisées pour les opérations de base de données utilisées aujourd'hui.
                        Ils offrent toutes les opérations CRUD de base ainsi que des fonctionnalités avancées pour effectuer des analyses.
                        Contrairement à MongoDB, il s'agit d'un système de gestion de base de données relationnelle, ce qui signifie que toutes les données doivent être
                        stockés dans des rangées bien structurées avec des colonnes fixes.
                    `,
                },
                title: {
                    en: 'SQL',
                    fr: 'SQL',
                },
            },
            webBasics: {
                bullets: {
                    en: [
                        'HTML5 with knowledge of how to structure a page semantically, using elements like header, nav, footer, etc.',
                        'JavaScript with knowledge of the latest features up to ES2021, including nullish coalescing, optional chaining, DOM manipulation, and let/const usage',
                        'CSS3 with knowledge of flex and grid layouts, animatable properties, media queries, and the basics of container queries',
                        'Knowledge of API design, authentication, and validation, and experience creating endpoints with Node.js and Express',
                        'Funtional programming experience using composable functions and the Ramda library',
                        'Responsive design experience (try this website on your phone, tablet, desktop, and ultrawide!)',
                        'Experience working with dynamic content like themes and internationalization (try the switchers found under the navbar!)',
                        'Experience working with third-party design libraries like Material UI and Ant Design',
                        'Basic knowledge of static asset optimization and resource preloading',
                    ],
                    fr: [
                        "HTML5 avec une connaissance de la structure sémantique d'une page, en utilisant des éléments tels que l'en-tête, la navigation, le pied de page, etc.",
                        "JavaScript avec connaissance des dernières fonctionnalités jusqu'à ES2021, y compris la coalescence nulle, le chaînage facultatif, la manipulation DOM et l'utilisation let/const",
                        'CSS3 avec une connaissance des mises en page flexibles et en grille, des propriétés animables, des requêtes multimédias et des bases des requêtes de conteneur',
                        "Connaissance de la conception, de l'authentification et de la validation d'API, et expérience de la création de points de terminaison avec Node.js et Express",
                        "Expérience de programmation fonctionnelle à l'aide de fonctions composables et de la bibliothèque Ramda",
                        'Expérience de conception réactive (essayez ce site Web sur votre téléphone, tablette, ordinateur de bureau et ultra large!)',
                        "Expérience de travail avec du contenu dynamique comme les thèmes et l'internationalisation (essayez les commutateurs trouvés sous la barre de navigation!)",
                        'Expérience de travail avec des bibliothèques de conception tierces telles que Material UI et Ant Design',
                        "Connaissance de base de l'optimisation des actifs statiques et du préchargement des ressources",
                    ],
                },
                bulletsDescription: {
                    en: "Here's a breakdown of some of the basic web development skills I know:",
                    fr: 'Voici une ventilation de certaines des compétences de base en développement Web que je connais:',
                },
                description: {
                    en: `
                        Frontend web development is truly my forte, as building user interfaces that are a joy to
                        use and provide a great UX is where I have the most fun! As a result, I try to keep up
                        with the latest web features so I can always write modern and concise code (very excited 
                        for container queries!). While I mostly work in React, it's important to also have a deep
                        understanding of the fundamentals of the web.
                    `,
                    fr: `
                        Le développement Web frontend est vraiment mon point fort, car la création d'interfaces utilisateur qui sont un plaisir à
                        utiliser et fournir une super UX est là où je m'amuse le plus ! En conséquence, j'essaie de suivre
                        avec les dernières fonctionnalités Web afin que je puisse toujours écrire du code moderne et concis (très excité
                        pour les requêtes de conteneur!). Bien que je travaille principalement dans React, il est important d'avoir également une connaissance approfondie
                        comprendre les fondamentaux du web.
                    `,
                },
                title: {
                    en: 'Basics',
                    fr: 'Bases',
                },
            },
        },
        subtitle: {
            en: `
                Creating fun and functional user interfaces that prioritize digital 
                accessibility for all audiences is truly what I love to build.
                Using React and CSS, I've made hundreds of components that utilize 
                microinteractions to provide a visual response to user actions, and 
                adhere to the WCAG2.1 specification for accessibility. But, I've also 
                had a significant amount of experience with backend technologies, like
                Elasticsearch for enhanced data filtering, Node.js for creating a permission
                managing microservice, and MongoDB for storing client preferences. **Click a 
                logo below to learn more!**
            `,
            fr: `
                Créer des interfaces utilisateur amusantes à utiliser, offrant une expérience 
                utilisateur transparente et accessibles à tous, c'est vraiment ce que j'aime créer. 
                En utilisant React et CSS, j'ai créé des centaines de composants qui utilisent des 
                micro-interactions pour fournir une réponse visuelle aux actions de l'utilisateur 
                et adhèrent à la spécification WCAG2.1 pour l'accessibilité. Mais, j'ai également 
                une grande expérience des technologies backend, comme Elasticsearch pour un filtrage 
                amélioré des données, Node.js pour la création d'un microservice de gestion des 
                autorisations et MongoDB pour le stockage des préférences des clients. **Cliquez sur un 
                logo ci-dessous pour en savoir plus!**
            `,
        },
        title: {
            en: 'Frontend Focused, Data Driven',
            fr: 'Axé sur le frontend, piloté par les données',
        },
    },
}
